module.exports = __webpack_public_path__ + "static/assets/c76d80f4d5b8e6f373a1604f56ebb5ec.png";